/**
 * Created by Alex Aguilar on 6/23/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('baseRatesCargoCtrl', baseRatesCargoCtrl)
        .controller('baseRateCargoEditCtrl', baseRateCargoEditCtrl);

    baseRatesCargoCtrl.$inject = ['linkService','baseRates'];
    baseRateCargoEditCtrl.$inject = ['baseRateService', '$stateParams','baseRate'];

    function baseRatesCargoCtrl(linkService,baseRates){
        var vm = this;
        vm.linkService = linkService;

        vm.baseRates = (baseRates.data._embedded) ? baseRates.data._embedded.baserates : [];
        vm.pages = baseRates.data.page;
        vm.searchRecords = "";
    }

    function baseRateCargoEditCtrl(baseRateService, $stateParams, baseRate){
        var vm = this;
        vm.baseRate = baseRate.data;

        vm.saveBaseRatCargo = function(isValid, baseRate){
            if(isValid){
                baseRateService.updateBaseRate($stateParams.id, baseRate, 'baseRatesCargo');
            }
        }
    }
})();
